import React from 'react';
import './Preview.css';

function Preview({ meta }) {
  const formatDuration = (seconds) => {
    if (!seconds) return '--:--';
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, '0');
    const s = Math.floor(seconds % 60)
      .toString()
      .padStart(2, '0');
    return `${m}:${s}`;
  };

  return (
    <div className="preview">
      <img
        src={meta.cover || meta.thumbnail || '/placeholder.jpg'}
        alt="Cover art"
        className="cover"
        onError={(e) => {
          e.target.src = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 200 200%22%3E%3Crect fill=%22%23e5e7eb%22 width=%22200%22 height=%22200%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 dominant-baseline=%22middle%22 text-anchor=%22middle%22 font-size=%2240%22 fill=%22%239ca3af%22%3E🎵%3C/text%3E%3C/svg%3E';
        }}
      />
      <div className="meta">
        <h3 className="title">{meta.title || 'Unknown title'}</h3>
        <div className="artist">{meta.artist || 'Unknown artist'}</div>
        {meta.album && <div className="album">{meta.album}</div>}
        <div className="duration">{formatDuration(meta.duration)}</div>
        {meta.year && <div className="year">{meta.year}</div>}
      </div>
    </div>
  );
}

export default Preview;
